import React, { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const FunctionDetails = ({ func }) => {
  const [openImage, setOpenImage] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width:600px)");

  if (!func) return null;

  return (
    <Box className="function-section">
      <Typography variant="h4" align="center" sx={{ fontWeight: 700, mb: 2, px: 2 }}>
        {func.title}
      </Typography>

      {/* VIDEO SLIDER */}
      <Box className="slider-wrapper">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={24}
          slidesPerView={isMobile ? 1 : 3}
          navigation
          pagination={{ clickable: true }}
          grabCursor
          className="function-swiper"
        >
          {func.videos.map((video, index) => (
            <SwiperSlide key={index}>
              <VideoSlide video={video} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* IMAGE SLIDER */}
      <Box className="slider-wrapper">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={24}
          slidesPerView={isMobile ? 1 : 3}
          navigation
          pagination={{ clickable: true }}
          grabCursor
          className="function-swiper"
        >
          {func.images.map((img, index) => (
            <SwiperSlide key={index}>
              <div
                className="image-card"
                onClick={() => { setCurrentIndex(index); setOpenImage(true); }}
              >
                <img src={img} alt={`function-${index}`} loading="lazy" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* IMAGE POPUP */}
      {openImage && (
        <div className="image-popup">
          <button className="close-btn" onClick={() => setOpenImage(false)}>✕</button>
          <button className="nav-btn prev" onClick={() => setCurrentIndex(prev => prev === 0 ? func.images.length - 1 : prev - 1)}>❮</button>
          <img src={func.images[currentIndex]} alt="Full View" className="popup-image" />
          <button className="nav-btn next" onClick={() => setCurrentIndex(prev => prev === func.images.length - 1 ? 0 : prev + 1)}>❯</button>
        </div>
      )}
    </Box>
  );
};

const VideoSlide = ({ video }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  return (
    <div className="slide-center">
      <div className="video-card">
        {!isPlaying ? (
          <>
            <img src={video.thumbnail} alt={video.title} onClick={() => setIsPlaying(true)} />
            <div className="video-overlay" onClick={() => setIsPlaying(true)}>
              <PlayArrowIcon style={{ fontSize: 70, color: "#FFD700" }} />
            </div>
          </>
        ) : (
          <video src={video.file} controls autoPlay preload="metadata" />
        )}
        <div className="video-title">{video.title}</div>
      </div>
    </div>
  );
};

export default FunctionDetails;
